import script from "./ArtifactListDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArtifactListDisplay.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QVirtualScroll});
